import { CustomLinkFund } from '../../pages/donate/donate-form/donate-form.model';
import { CharityProject } from './SearchCharity';
import { Fund } from './fund';

export class Charity {
  cseg5: string;
  id?: string;
  fundNumber: string;
  fundNumberDisplay?: string;
  fundType: string;
  status: string;
  name: string;
  value: string;
  expired: boolean;
  networkMember?: string;

  constructor(
    charityData: CharityDto | TransferCharityDto | Fund | CharityProject | CustomLinkFund,
    expired?: boolean,
    isProject = false
  ) {
    if (charityData) {
      this.cseg5 = charityData.cseg5;
      this.id = (charityData as CharityDto).id;
      this.name = isProject
        ? (charityData as CharityProject).entityName
        : (charityData as CustomLinkFund).name || charityData.fundName;
      this.fundNumber = charityData.fundNumber;
      this.fundNumberDisplay = charityData.fundNumberDisplay;
      this.value = `${this.name} (#${this.fundNumberDisplay || this.fundNumber})`;
      this.fundType = this.setType(charityData);
      if (Object.keys(charityData).includes('status'))
        this.status = (charityData as CharityDto).status;
      this.networkMember = (charityData as CharityDto).networkMember;
    }
    this.expired = expired;
  }

  setType(charityData: any): string {
    if (Object.keys(charityData).includes('fundType')) return charityData.fundType;
    if (Object.keys(charityData).includes('type')) return charityData.type;
  }
}

export interface CharityDto {
  cseg5: string;
  id?: string;
  fundName: string;
  fundNumber: string;
  fundNumberDisplay?: string;
  fundType: string;
  status: string;
  networkMember?: string;
}

export interface TransferCharityDto {
  cseg5: string;
  fundName: string;
  fundNumber: string;
  fundNumberDisplay?: string;
  type: string;
}

export enum ProjectStatus {
  APPROVED = 'Project Application Approved',
}
